module.exports = __webpack_public_path__ + "images/tr_repository/init-repository-e0ad3a33fa31ff1c546da4284644192c.png";